<dynamic-form-v2
    *ngIf="!isLoading"
    entityType="localization-configuration"
    [formName]="title"
    [record]="localizationConfigRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
>
</dynamic-form-v2>
